<template>
    <footer class="footer">
      <div class="footer-1">
        <a target="_blank" href="#">联系我们</a>
        <a target="_blank" href="http://admin.njxianhe.com">后台管理</a>
      </div>
      <div class="footer-2">
        <span class="font-style">版权所有：南京先河工程技术股份有限公司</span>
        <a target="_blank" href="http://beian.miit.gov.cn/">苏ICP备20043743号</a>
        <a target="_blank" href="#">技术支持：鑫松工作室</a>
      </div>
      <div class="footer-3">
        <span>本网站推荐浏览器为：IE 9+,Safari,Chrome 38+,Firefox 32+,etc.</span>
      </div>
      
    </footer>
</template>

<script>
   export default {
    name: 'Footer',
    data() {
      return {
       
      }
    },
    computed: {

    }
  }

</script>

<style lang="less" scoped>
.footer {
  /* color: #409EFF; */
  font-size: 0.21rem;
  text-align: center;
  padding: 0.3rem 0;
  background: #787878;
  color: #fff;
  a {
    color: #fff;
  }
  .footer-1, .footer-2 {
    margin-bottom: 0.2rem;
     a {
      margin-right: 0.2rem;
    }
  }
  .footer-2 {
    .font-style {
      margin-right: 0.2rem;
    }
  }
}
</style>